import {_ as $aWbP0$_} from "@swc/helpers/_/_object_spread";
import {_ as $aWbP0$_1} from "@swc/helpers/_/_object_spread_props";
import {fg as $aWbP0$fg} from "@atlaskit/platform-feature-flags";
import $aWbP0$atlassiansoxanalyticswebclient, {originType as $aWbP0$originType} from "@atlassiansox/analytics-web-client";
import {_ as $aWbP0$_2} from "@swc/helpers/_/_object_without_properties";
import {jsx as $aWbP0$jsx} from "react/jsx-runtime";
import {useRef as $aWbP0$useRef, useCallback as $aWbP0$useCallback, useEffect as $aWbP0$useEffect, useMemo as $aWbP0$useMemo, useState as $aWbP0$useState} from "react";
import $aWbP0$atlaskitflag, {AutoDismissFlag as $aWbP0$AutoDismissFlag} from "@atlaskit/flag";
import $aWbP0$atlaskitbanner from "@atlaskit/banner";
import $aWbP0$atlaskitmodaldialog from "@atlaskit/modal-dialog";
import {Popper as $aWbP0$Popper} from "@atlaskit/popper";
import {Spotlight as $aWbP0$Spotlight} from "@atlaskit/onboarding";
import $aWbP0$atlaskitinlinedialog from "@atlaskit/inline-dialog";
import {Popup as $aWbP0$Popup} from "@atlaskit/popup";




function $701dcb43bda5dd6a$var$getCurrentLoggingLevel() {
    return window.choreographerLoggingLevel;
}
function $701dcb43bda5dd6a$var$logMessageIfValidLoggingLevel(loggingLevel, data) {
    if ($701dcb43bda5dd6a$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.table(data);
}
function $701dcb43bda5dd6a$var$traceMessageIfValidLoggingLevel(loggingLevel, productId, messageId, message) {
    if ($701dcb43bda5dd6a$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.log(`CHOREOGRAPHER - ${productId} - ${messageId} - ${message}`);
}
class $701dcb43bda5dd6a$export$21e6cc849c1dc1ab {
    constructor(productId, messageId){
        /**
	 * A function that takes an object of properties for each logging level
	 * name, e.g. log.info and log.verbose, which are functions that take an
	 * object of any key/value pairs, which will be merged with the productId
	 * and the messageId values passed to the constructor, and output via
	 * console.table.
	 *
	 * Example: debugLogger.log({
	 *   info: { foo: true },
	 *   verbose: {
	 *     foo: true,
	 *     bar: 123,
	 *     baz 'abc',
	 *     timestamp: performance.now()
	 *   },
	 * });
	 *
	 * @param messages Record<LoggingLevels, Record<string, unknown>> An object
	 * keyed by the desired log-level, with each value being an object of any
	 * key/value pairs to be output to console.table.
	 */ this.log = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                var _messages_loggingLevel;
                $701dcb43bda5dd6a$var$logMessageIfValidLoggingLevel(loggingLevel, (0, $aWbP0$_)({
                    productId: this.state.productId,
                    messageId: this.state.messageId
                }, (_messages_loggingLevel = messages[loggingLevel]) !== null && _messages_loggingLevel !== void 0 ? _messages_loggingLevel : {}, loggingLevel === "verbose" ? {
                    timestamp: performance.now()
                } : {}));
            });
        };
        /**
	 * A function that takes an object of properties for each logging level
	 * name, e.g. trace.info and trace.verbose, which are functions that take
	 * a string to be used as the label for a stack trace via console.trace.
	 *
	 * Example: debugLogger.trace({
	 *   info: 'This is a stack trace',
	 *   verbose: `This is a stack trace with a much more verbose message which
	 * contains data about the ${productId} and ${messageId} within my function,
	 * invoked at ${performance.now()}ms`,
	 * });
	 *
	 * @param messages Record<LoggingLevels, string> An object keyed by the
	 * desired log-level, with each value being a string to be output as the
	 * label to console.trace.
	 */ this.trace = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $701dcb43bda5dd6a$var$traceMessageIfValidLoggingLevel(loggingLevel, this.state.productId, this.state.messageId, `${messages[loggingLevel]}${loggingLevel === "verbose" ? ` (${performance.now()})` : ""}`);
            });
        };
        this.state = {
            productId: productId,
            messageId: messageId
        };
    }
}




const $6580532afc76cccf$export$d33b097e0a285bc2 = {
    START: "start",
    STOP: "stop"
};
const $6580532afc76cccf$export$f6a9504bc1305cf0 = {
    BLOCKED: "blocked",
    CANCELED: "canceled",
    ERROR: "error",
    STARTED: "started",
    STOPPED: "stopped",
    UNREGISTERED: "unregistered"
};
var $6580532afc76cccf$export$7fb117db98868be6;
(function(ProductIds) {
    ProductIds["CONFLUENCE"] = "confluence";
    ProductIds["ENGAGEKIT"] = "Engagekit";
    ProductIds["INTERCOM"] = "intercom";
    ProductIds["JIRA"] = "jira";
    ProductIds["PENDO"] = "pendo";
    ProductIds["CLOUDADMIN"] = "cloudadmin";
    ProductIds["BITBUCKET"] = "bitbucket";
})($6580532afc76cccf$export$7fb117db98868be6 || ($6580532afc76cccf$export$7fb117db98868be6 = {}));
const $6580532afc76cccf$export$94e85cf3348f045a = {
    ENGAGEMENT: "engagement",
    MARKETING: "marketing",
    TRANSACTIONAL: "transactional"
};
const $6580532afc76cccf$export$dbe9e38c9d6f26d0 = [
    $6580532afc76cccf$export$94e85cf3348f045a.ENGAGEMENT,
    $6580532afc76cccf$export$94e85cf3348f045a.MARKETING
];
const $6580532afc76cccf$export$865c0eaaa43d90f8 = {
    START: "messageStart",
    STOP: "messageStop"
};
const $6580532afc76cccf$export$fc6a8b8cb405f50 = {
    INFO: "info",
    VERBOSE: "verbose"
};


class $8368be1d2c44bc45$export$efa9a398d6368992 {
    /**
	 * Send operational event to the Analytics web client for logging/metrics.
	 *
	 * @param action A (MessageDeliveryStatuses) string denoting the ultimate disposition of this message start or stop request.
	 */ sendOperationalEvent(action, additionalAttributes) {
        if ((0, $aWbP0$fg)("platform.post-office.enable-full-choreographer-logging")) {
            const { analyticsClient: analyticsClient, actionSubject: actionSubject, actionSubjectId: actionSubjectId, metricsData: attributes } = this.state;
            analyticsClient.sendOperationalEvent({
                source: "choreographer",
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                attributes: (0, $aWbP0$_)({}, attributes !== null && attributes !== void 0 ? attributes : {}, additionalAttributes !== null && additionalAttributes !== void 0 ? additionalAttributes : {}),
                tags: [
                    "postOffice"
                ]
            });
        }
    }
    blocked(additionalAttributes) {
        this.sendOperationalEvent((0, $6580532afc76cccf$export$f6a9504bc1305cf0).BLOCKED, additionalAttributes);
    }
    error(additionalAttributes) {
        this.sendOperationalEvent((0, $6580532afc76cccf$export$f6a9504bc1305cf0).ERROR, additionalAttributes);
    }
    unregistered(additionalAttributes) {
        this.sendOperationalEvent((0, $6580532afc76cccf$export$f6a9504bc1305cf0).UNREGISTERED, additionalAttributes);
    }
    started(additionalAttributes) {
        this.sendOperationalEvent((0, $6580532afc76cccf$export$f6a9504bc1305cf0).STARTED, additionalAttributes);
    }
    stopped(additionalAttributes) {
        this.sendOperationalEvent((0, $6580532afc76cccf$export$f6a9504bc1305cf0).STOPPED, additionalAttributes);
    }
    /**
	 * Utility class to simplify and allow for wider use of sending operational event to the Analytics web client for logging/metrics.
	 *
	 * @param actionSubject A (MessageActions) string denoting either the start or stop phase of a message.
	 * @param actionSubjectId Unique messageId to be logged with this even.
	 * @param metricsData Additional data from plugin to be sent with event for metrics logging.
	 * @param analyticsClient An instance of AnalyticsWebClient, unique to each caller
	 */ constructor(actionSubject, actionSubjectId, metricsData, analyticsClient){
        this.state = {
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            metricsData: metricsData,
            analyticsClient: analyticsClient
        };
    }
}



// This timeout is used for any long-running messages that are either stuck for some reason, or that the user has yet to clear, to ensure that messaging doesn't stay blocked indefinitely
const $63a45429e45394fc$var$CHOREOGRAPHER_MESSAGE_TTL = 300000; // 5 minute TTL for messages
// Lazily instantiate this the first time it's requested
let $63a45429e45394fc$var$singleton;
class $63a45429e45394fc$export$236158f15971c92e {
    /**
	 * Static method to create and/or return a singleton of the choreographer API.
	 *
	 * @returns Shared instance of choreographer API.
	 */ static getInstance() {
        if (!$63a45429e45394fc$var$singleton) $63a45429e45394fc$var$singleton = new this();
        return $63a45429e45394fc$var$singleton;
    }
    stopCurrentMessage() {
        if (this.state.currentMessage) this.stopMessageInternal(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData, true).then(()=>{
            // Manually clear the message TTL and reenable plugins here just in case the unregistered plugin's message denied the
            // stop request. We may still get a collision on-screen, but we're considering the message forcibly stopped at this
            // point, so need to allow new requests.
            this.clearMessageTtl();
            this.enablePlugins();
        });
    }
    /**
	 * Enables the message queue, and logs which message everybody else is queueing up behind.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request blocking others.
	 * @param messageId Unique identifier for the messageId blocking others.
	 */ queueMessages(productId, messageId) {
        this.state.shouldQueueMessages = true;
        this.state.queueingBehindMessage = {
            productId: productId,
            messageId: messageId
        };
    }
    /**
	 * Pushes all data associated with a startMessage request onto an internal queue, to potentially be processed at a later time.
	 * If a pending message request opts out (or otherwise fails to start), this data will be used to reinitiate the startMessage
	 * request for this message request instance. Returns a Promise that the caller can await as normal, and which will eventually
	 * either be resolved as 'blocked' if any prior pending message is started, or will be resolved with its eventual outcome when
	 * its startMessage request is processed.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request being queued.
	 * @param messageId Unique identifier for the messageId being queued.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance to prevent from being disabled when this request starts.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
        return new Promise((resolve)=>{
            this.state.messageQueue.push({
                productId: productId,
                messageId: messageId,
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                plugin: plugin,
                resolve: resolve
            });
        });
    }
    /**
	 * Responsible for pulling a previously queued message request that was received while a message request was already in flight.
	 * Shift the first message off the top of the queue, and use the stored resolve function to kickstart another pass through the
	 * startMessage function, ultimately resolving with the final disposition of the request. Set the internal state for shouldQueueMessages
	 * to false if we're restarting a startMessage request, so that this doesn't get immediately thrown back into the queue. If it
	 * makes it through to its start callback being fired, that code will turn the shouldQueueMessages state back on.
	 */ processQueuedMessage() {
        const queuedMessage = this.state.messageQueue.shift();
        // Disable the shouldQueueMessages state here. If we have a queued message, it will turn the shouldQueueMessages state back on when it
        // hits the call to its message's startCallback function. Otherwise, the queue is now empty, and we let things process normally.
        this.state.shouldQueueMessages = false;
        if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
    }
    /**
	 * Responsible for flushing out any queued messages and resolving their Promises as "blocked". We don't officially consider a
	 * message as "blocked" until one of the prior calls has signaled a valid "started" state. This way, any async callbacks that
	 * are in flight can allow additional messages to queue up, and if they eventually opt out, we can move on to the next message
	 * in the queue and see if it will signal success. Only when we get a successful start to we consider all queued up messages to
	 * be "blocked". Run a loop to shift each of them off of the array and resolve them as blocked, until the array is empty.
	 */ destroyMessageQueue() {
        this.state.shouldQueueMessages = false;
        this.state.queueingBehindMessage = null;
        while(this.state.messageQueue.length > 0){
            var _this_state_currentMessage, _this_state_currentMessage1;
            const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
            const attributes = (0, $aWbP0$_1)((0, $aWbP0$_)({}, metricsData), {
                productId: productId,
                messageId: messageId
            });
            const actionSubject = (0, $6580532afc76cccf$export$865c0eaaa43d90f8).START;
            const logger = new (0, $8368be1d2c44bc45$export$efa9a398d6368992)(actionSubject, messageId, attributes, analyticsClient);
            const debugLogger = new (0, $701dcb43bda5dd6a$export$21e6cc849c1dc1ab)(productId, messageId);
            logger.blocked({
                blockedByProductId: (_this_state_currentMessage = this.state.currentMessage) === null || _this_state_currentMessage === void 0 ? void 0 : _this_state_currentMessage.productId,
                blockedByMessageId: (_this_state_currentMessage1 = this.state.currentMessage) === null || _this_state_currentMessage1 === void 0 ? void 0 : _this_state_currentMessage1.messageId
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $6580532afc76cccf$export$f6a9504bc1305cf0).BLOCKED
                }
            });
            resolve((0, $6580532afc76cccf$export$f6a9504bc1305cf0).BLOCKED);
        }
    }
    /**
	 * Sets a timeout to auto-expire any messaging that stays open for too long, to prevent messaging from being blocked indefinitely.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
	 * @param messageId Unique identifier for the messageId that triggered this message timeout.
	 * @param AnalyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 */ setMessageTtl(productId, messageId, analyticsClient, metricsData) {
        this.state.currentMessage = {
            productId: productId,
            messageId: messageId,
            analyticsClient: analyticsClient,
            metricsData: metricsData,
            timestamp: Date.now()
        };
        this.state.messageTtl = setTimeout(()=>{
            if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
        }, $63a45429e45394fc$var$CHOREOGRAPHER_MESSAGE_TTL);
    }
    /**
	 * Checks to see if the requesting productId/messageId pair matches the data for the currently-displayed message.
	 *
	 * @param productId Unique identifier for the product being checked for a current message match.
	 * @param messageId Unique identifier for the messageId being checked for a current message match.
	 */ isCurrentMessage(productId, messageId) {
        return Boolean(this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId);
    }
    /**
	 * Returns the currentMessage object.
	 */ getCurrentMessage() {
        return this.state.currentMessage;
    }
    /**
	 * Clears the timeout that was established for the currently-displayed message.
	 */ clearMessageTtl() {
        this.state.currentMessage = null;
        if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
    }
    /**
	 * Disables all plugins that are currently registered with the choreographer, called when a startMessage call is being dispatched.
	 *
	 * @param [exceptFor] An optional plugin instance to exclude from the items being disabled, e.g. the plugin responsible for the current startMessage call.
	 */ disablePlugins(exceptFor) {
        this.state.isDisabled = true;
        [
            ...this.state.plugins.values()
        ].forEach((p)=>{
            if (p !== exceptFor) p.disable();
        });
    }
    /**
	 * Enables all plugins that are currently registered with the choreographer, called when a matching stopMessage call is successful.
	 */ enablePlugins() {
        [
            ...this.state.plugins.values()
        ].forEach((p)=>p.enable());
        this.state.isDisabled = false;
    }
    /**
	 * A callback used to remove a plugin from the list of subscribers for the choreographer service.
	 *
	 * @param productId A unique string representing the plugin to be unregistered from the choreographer API.
	 */ unregisterPlugin(productId) {
        var _this_state_currentMessage;
        // If we're unregistering this productId's plugin, and the currentMessage is from this productId, we need to stop it to clear the choreographer
        if (((_this_state_currentMessage = this.state.currentMessage) === null || _this_state_currentMessage === void 0 ? void 0 : _this_state_currentMessage.productId) === productId) this.stopCurrentMessage();
        this.state.messages.delete(productId);
        this.state.plugins.delete(productId);
    }
    /**
	 * Determines whether any message is currently being displayed, by checking its own status and optionally, asking each registered plugin for its individual status.
	 *
	 * @returns A value reflecting whether a message is currently being displayed on screen.
	 */ isDisplayingMessage() {
        return Boolean(this.state.currentMessage || [
            ...this.state.plugins.values()
        ].reduce((isDisplayingMessage, p)=>{
            return isDisplayingMessage || p.isDisplayingMessage();
        }, false));
    }
    /**
	 * This function is intended for test cleanup purposes only, *not* to be called by external callers.
	 *
	 * @ignore
	 * @param productId Unique identifier for the product whose messages are being requested
	 * @returns A Map of IMessage objects, keyed by unique messageId strings.
	 */ getMessages(productId) {
        var _this_state_messages_get;
        return (_this_state_messages_get = this.state.messages.get(productId)) !== null && _this_state_messages_get !== void 0 ? _this_state_messages_get : new Map();
    }
    /**
	 * Requests to start a message via the choreographer service, ensuring only a single message instance at a time on the screen.
	 * A successful request will block any other message attempts until such time as the matching stopMessage request is received,
	 * or a message TTL timeout has expired.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
	 * @param messageId Unique identifier for the messageId that triggered this message timeout.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance to prevent from being disabled when this request starts.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        const debugLogger = new (0, $701dcb43bda5dd6a$export$21e6cc849c1dc1ab)(productId, messageId);
        const actionSubject = (0, $6580532afc76cccf$export$865c0eaaa43d90f8).START;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = (0, $aWbP0$_1)((0, $aWbP0$_)({}, metricsData), {
            productId: productId,
            messageId: messageId
        });
        const logger = new (0, $8368be1d2c44bc45$export$efa9a398d6368992)(actionSubject, messageId, attributes, analyticsClient);
        try {
            var _message_start;
            if (!this.hasMessageRecord(productId, messageId)) {
                // Bail early here, before even checking if we're in a queueing situation, or blocked, or anything else
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $6580532afc76cccf$export$f6a9504bc1305cf0).UNREGISTERED
                    }
                });
                return (0, $6580532afc76cccf$export$f6a9504bc1305cf0).UNREGISTERED;
            }
            // If we're currently queueing messages, push this one onto the queue and return the new Promise
            if (this.state.shouldQueueMessages) {
                var _this_state_queueingBehindMessage, _this_state_queueingBehindMessage1;
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: `queued behind ${(_this_state_queueingBehindMessage = this.state.queueingBehindMessage) === null || _this_state_queueingBehindMessage === void 0 ? void 0 : _this_state_queueingBehindMessage.productId} ${(_this_state_queueingBehindMessage1 = this.state.queueingBehindMessage) === null || _this_state_queueingBehindMessage1 === void 0 ? void 0 : _this_state_queueingBehindMessage1.messageId}`
                    }
                });
                return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
            }
            if (this.state.isDisabled || this.isDisplayingMessage()) {
                var _this_state_currentMessage, _this_state_currentMessage1;
                logger.blocked({
                    blockedByProductId: (_this_state_currentMessage = this.state.currentMessage) === null || _this_state_currentMessage === void 0 ? void 0 : _this_state_currentMessage.productId,
                    blockedByMessageId: (_this_state_currentMessage1 = this.state.currentMessage) === null || _this_state_currentMessage1 === void 0 ? void 0 : _this_state_currentMessage1.messageId
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $6580532afc76cccf$export$f6a9504bc1305cf0).BLOCKED
                    }
                });
                return (0, $6580532afc76cccf$export$f6a9504bc1305cf0).BLOCKED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            this.queueMessages(productId, messageId);
            var _ref;
            const didStart = (_ref = await ((_message_start = message.start) === null || _message_start === void 0 ? void 0 : _message_start.call(message))) !== null && _ref !== void 0 ? _ref : true;
            if (didStart) {
                var // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                _message_onStart;
                (_message_onStart = message.onStart) === null || _message_onStart === void 0 ? void 0 : _message_onStart.call(message);
                logger.started();
                this.disablePlugins(plugin);
                this.setMessageTtl(productId, messageId, analyticsClient, metricsData);
                // Successfully started the message, flush the queue and mark any pending requests as "blocked"
                this.destroyMessageQueue();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $6580532afc76cccf$export$f6a9504bc1305cf0).STARTED
                    }
                });
                return (0, $6580532afc76cccf$export$f6a9504bc1305cf0).STARTED;
            }
            // Check to see if we have any pending requests in the message queue and attempt to start the next one in line
            this.processQueuedMessage();
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $6580532afc76cccf$export$f6a9504bc1305cf0).CANCELED
                }
            });
            return (0, $6580532afc76cccf$export$f6a9504bc1305cf0).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $6580532afc76cccf$export$f6a9504bc1305cf0).ERROR
                }
            });
            return (0, $6580532afc76cccf$export$f6a9504bc1305cf0).ERROR;
        }
    }
    /**
	 * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
	 * This version of the stopMessage function is private, and only intended to be called internally, so that it can make use of the forceStop parameter without exposing that to external callers.
	 *
	 * @param productId Unique identifier for the product making the current stopMessage request.
	 * @param messageId Unique identifier for the messageId to be stopped.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @param forceStop A boolean to denote whether to forcefully clear the Choreographer's blocked state (used for TTL expiration and unregistering a plugin).
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessageInternal(productId, messageId, analyticsClient, metricsData = {}, forceStop = false) {
        const debugLogger = new (0, $701dcb43bda5dd6a$export$21e6cc849c1dc1ab)(productId, messageId);
        const actionSubject = (0, $6580532afc76cccf$export$865c0eaaa43d90f8).STOP;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = (0, $aWbP0$_1)((0, $aWbP0$_)({}, metricsData), {
            productId: productId,
            messageId: messageId
        });
        const logger = new (0, $8368be1d2c44bc45$export$efa9a398d6368992)(actionSubject, messageId, attributes, analyticsClient);
        try {
            var _message_stop;
            if (!this.hasMessageRecord(productId, messageId)) {
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $6580532afc76cccf$export$f6a9504bc1305cf0).UNREGISTERED
                    }
                });
                return (0, $6580532afc76cccf$export$f6a9504bc1305cf0).UNREGISTERED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            // Enable the message queue *if* the current stopMessage request matches the currentMessage data.
            // Any incoming startMessage requests will be queued while this stopMessage request is in-flight,
            // so that they can be immediately honored if this request comes back successfully.
            if (this.isCurrentMessage(productId, messageId)) this.queueMessages(productId, messageId);
            var _ref;
            const didStop = (_ref = await ((_message_stop = message.stop) === null || _message_stop === void 0 ? void 0 : _message_stop.call(message))) !== null && _ref !== void 0 ? _ref : true;
            // If we're hitting this from stopCurrentMessage, it means either a TTL has expired, or we're
            // unregistering a plugin. We forceStop the choreographer blocked state here, even if the stop
            // callback returned false.We don't want to block the UI indefinitely, we'll just have to risk
            // 1 additional message collision if the current message's stop callback refuses to clear.
            if (didStop || forceStop) {
                if (this.isCurrentMessage(productId, messageId)) {
                    var // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    _message_onStop;
                    (_message_onStop = message.onStop) === null || _message_onStop === void 0 ? void 0 : _message_onStop.call(message);
                    // Only log this even if we're stopping the current message, so we have a 1:1 mapping of starts to stops.
                    // If this is a forced stop, log that in the attributes, so we can track those events specifically.
                    // Also log the value of didStop, so we know if this was a rejected stop attempt that *had* to be force stopped.
                    logger.stopped(forceStop ? {
                        forceStop: forceStop,
                        didStop: didStop
                    } : undefined);
                    // Only clear the message TTL and reenable plugins if we're stopping the *current* message
                    this.clearMessageTtl();
                    this.enablePlugins();
                }
                // Check to see if we have any pending requests in the message queue and attempt to start them
                this.processQueuedMessage();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $6580532afc76cccf$export$f6a9504bc1305cf0).STOPPED
                    }
                });
                return (0, $6580532afc76cccf$export$f6a9504bc1305cf0).STOPPED;
            }
            // Stopping the message failed, so the UI is still intentionally blocked, flush the queue and mark any pending requests as "blocked"
            this.destroyMessageQueue();
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $6580532afc76cccf$export$f6a9504bc1305cf0).CANCELED
                }
            });
            return (0, $6580532afc76cccf$export$f6a9504bc1305cf0).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $6580532afc76cccf$export$f6a9504bc1305cf0).ERROR
                }
            });
            return (0, $6580532afc76cccf$export$f6a9504bc1305cf0).ERROR;
        }
    }
    /**
	 * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
	 *
	 * @param productId Unique identifier for the product making the current stopMessage request.
	 * @param messageId Unique identifier for the messageId to be stopped.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessage(productId, messageId, analyticsClient, metricsData = {}) {
        return this.stopMessageInternal(productId, messageId, analyticsClient, metricsData);
    }
    /**
	 * Registers a plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
	 *
	 * @param productId Unique identifier to register as the product owner of this plugin.
	 * @param plugin A plugin instance to be registered with the choreographer instance.
	 * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
	 */ registerPlugin(productId, plugin) {
        if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
        this.state.plugins = this.state.plugins.set(productId, plugin);
        if (this.state.isDisabled) plugin.disable();
        return ()=>{
            this.unregisterPlugin(productId);
        };
    }
    /**
	 * Validates that a message record is present and ready to be retrieved and/or manipulated.
	 * Creates the message instance if it doesn't yet exist, initializing both start and stop callbacks to noop functions.
	 *
	 * @param productId Unique identifier to retrieve map of IMessage objects.
	 * @param messageId Unique identifier for the messageId to be retrieved.
	 * @returns IMessage object for the requested productId/messageId combination.
	 */ ensureMessageRecord(productId, messageId) {
        let productMessages = this.state.messages.get(productId);
        if (!productMessages) {
            productMessages = new Map();
            this.state.messages.set(productId, productMessages);
        }
        let message = productMessages.get(messageId);
        if (!message) {
            message = {};
            productMessages.set(messageId, message);
        }
        return message;
    }
    /**
	 * Checks for the existance of a message record for a given productId/messageId combination.
	 *
	 * @param productId Unique identifier to check for a map of IMessage objects.
	 * @param messageId Unique identifier to check for within the map of productId IMessage objects.
	 * @returns Boolean indicating whether or not an IMessage record exists for the requested productId/messageId combination.
	 */ hasMessageRecord(productId, messageId) {
        var _this_state_messages_get_has, _this_state_messages_get;
        return Boolean((_this_state_messages_get = this.state.messages.get(productId)) === null || _this_state_messages_get === void 0 ? void 0 : (_this_state_messages_get_has = _this_state_messages_get.has) === null || _this_state_messages_get_has === void 0 ? void 0 : _this_state_messages_get_has.call(_this_state_messages_get, messageId));
    }
    /**
	 * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param options An object containing optional start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ on(productId, messageId, options = {}, finalizers = {}) {
        const message = (0, $aWbP0$_)({}, this.ensureMessageRecord(productId, messageId), options, finalizers);
        this.state.messages.get(productId).set(messageId, message);
    }
    /**
	 * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param startCallback A callback to be invoked upon successful requests to startMessage.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ onStart(productId, messageId, startCallback, finalizers) {
        this.on(productId, messageId, {
            start: startCallback
        }, finalizers);
    }
    /**
	 * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ onStop(productId, messageId, stopCallback, finalizers = {}) {
        this.on(productId, messageId, {
            stop: stopCallback
        }, finalizers);
    }
    /**
	 * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for unsubscribing this message.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for unsubscribing this message.
	 */ off(productId, messageId) {
        var _this_state_messages_get_delete, _this_state_messages_get;
        (_this_state_messages_get = this.state.messages.get(productId)) === null || _this_state_messages_get === void 0 ? void 0 : (_this_state_messages_get_delete = _this_state_messages_get.delete) === null || _this_state_messages_get_delete === void 0 ? void 0 : _this_state_messages_get_delete.call(_this_state_messages_get, messageId);
    }
    constructor(){
        this.state = {
            currentMessage: null,
            isDisabled: false,
            messages: new Map(),
            messageQueue: [],
            messageTtl: null,
            plugins: new Map(),
            queueingBehindMessage: null,
            shouldQueueMessages: false
        };
    }
}


var $bfa09a771ddec9c1$export$56ac8ebc9870b1b9;
(function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
})($bfa09a771ddec9c1$export$56ac8ebc9870b1b9 || ($bfa09a771ddec9c1$export$56ac8ebc9870b1b9 = {}));






class $ce60cbd40062948b$export$71324a662782c710 {
    /**
	 * Public method to clean up this plugin instance, which will handle unregistering it from the choreographer API.
	 */ destroy() {
        this.state.unregisterPlugin();
    }
    /**
	 * Determines whether this plugin is currently displaying a message on the screen. By default, is a simple boolean
	 * toggle that gets flipped back and forth, but it could also be a function that checks the DOM for a given message
	 * container to be present, or checks with some external API to tell it whether a message is being displayed, or
	 * anything else. The logic is up to the consumer to implement, if something custom is desired.
	 *
	 * @returns A boolean that represents whether this plugin is currently displaying a message on the screen.
	 */ isDisplayingMessage() {
        return this.state.isDisplayingMessage;
    }
    /**
	 * Sets the internal isDisplayingMessage state to true, to denote that this plugin is currently blocking the UI.
	 */ blockDisplayState() {
        this.state.isDisplayingMessage = true;
    }
    /**
	 * Sets the internal isDisplayingMessage state to false, to denote that this plugin is no longer blocking the UI.
	 */ clearDisplayState() {
        this.state.isDisplayingMessage = false;
    }
    /**
	 * Disables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
	 * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
	 * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
	 */ disable() {
        this.state.isDisabled = true;
    }
    /**
	 * Enables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
	 * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
	 * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
	 */ enable() {
        this.state.isDisabled = false;
    }
    /**
	 * Makes a request to start a message through the choreographer API. Will immediately return false if this plugin
	 * is currently in a disabled state, and will otherwise return the ultimate result of the startMessage request.
	 *
	 * @param messageId The messageId for the message to be started through the choreographer API.
	 * @param additionalData An object containing additional metadata to be sent along with the message start request
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ async startMessage(messageId, additionalData = {}) {
        return (0, $63a45429e45394fc$export$236158f15971c92e).getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, (0, $aWbP0$_)({}, this.state.metaMetricsData, additionalData), this);
    }
    /**
	 * Makes a request to stop a message through the choreographer API. Will return the ultimate result of the stopMessage request.
	 *
	 * @param messageId The messageId for the message to be stopped through the choreographer API.
	 * @param additionalData An object containing additional metadata to be sent along with the message stop request
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessage(messageId, additionalData = {}) {
        return (0, $63a45429e45394fc$export$236158f15971c92e).getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, (0, $aWbP0$_)({}, this.state.metaMetricsData, additionalData));
    }
    /**
	 * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param options An object containing start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
	 */ on(messageId, options = {}) {
        return (0, $63a45429e45394fc$export$236158f15971c92e).getInstance().on(this.state.productId, messageId, options, this.finalizers);
    }
    /**
	 * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param startCallback A callback to be invoked upon successful requests to startMessage.
	 */ onStart(messageId, startCallback) {
        return (0, $63a45429e45394fc$export$236158f15971c92e).getInstance().onStart(this.state.productId, messageId, startCallback, this.finalizers);
    }
    /**
	 * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
	 */ onStop(messageId, stopCallback) {
        return (0, $63a45429e45394fc$export$236158f15971c92e).getInstance().onStop(this.state.productId, messageId, stopCallback, this.finalizers);
    }
    /**
	 * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for unsubscribing this message subscription.
	 */ off(messageId) {
        return (0, $63a45429e45394fc$export$236158f15971c92e).getInstance().off(this.state.productId, messageId);
    }
    /**
	 * Registers this plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
	 *
	 * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
	 * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
	 */ registerPlugin(productId) {
        return (0, $63a45429e45394fc$export$236158f15971c92e).getInstance().registerPlugin(productId, this);
    }
    /**
	 * Creates a new instance of the Analytics Web Client for a plugin to use for sending analytics events.
	 *
	 * @param env environment type used to create the analytics client
	 * @returns AnalyticsWebClient instance
	 */ createAnalyticsClient(env) {
        const analyticsClient = new (0, $aWbP0$atlassiansoxanalyticswebclient)({
            env: env,
            product: "postOffice",
            origin: (0, $aWbP0$originType).WEB
        });
        return analyticsClient;
    }
    /**
	 * Instantiates a plugin to be used with the main choreographer API. Requires a productId string
	 * to be used for segmenting registered messageIds in other parts of the API, which ensures uniqueness
	 * between individual products for tracking purposes.
	 *
	 * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
	 * @param env The environment type for the product, to be used for analytics events.
	 * @param metaMetricsData An object containing additional metadata to be sent along with every message request.
	 * @returns A new instance of this plugin to use for integrating a 1P or 3P product with the choreographer API.
	 */ constructor(productId, env, metaMetricsData = {}){
        this.state = {
            isDisabled: false,
            isDisplayingMessage: false,
            metaMetricsData: metaMetricsData,
            productId: productId,
            unregisterPlugin: ()=>{}
        };
        this.analyticsClient = this.createAnalyticsClient(env);
        /**
		 * These finalizers are callbacks to be invoked after a valid start or stop request in the Choreographer core.
		 * Declaring them in the constructor because it's the same onStart/onStop pair that will be passed ot all of the
		 * .on, .onStart, and .onStop function registrations.
		 *
		 * This behavior used to be managed by a decorator function that would auto-set the isDisplayingMessage value
		 * whenever its start or stop callbacks were invoked. However, those start and stop callbacks are optional from
		 * this layer, so if a consumer did *not* register a stop callback, the display state would never be cleared here
		 * in the plugin, and would continue blocking messages.
		 *
		 * We're now passing these onStart and onStop callbacks as part of the message registration, so that any time a
		 * message is started or stopped at the core layer, we can fire these callbacks to update the plugin's local state,
		 * whether or not an actual start or stop callback was registered by the consumer.
		 */ this.finalizers = {
            onStart: ()=>this.blockDisplayState(),
            onStop: ()=>this.clearDisplayState()
        };
        this.state.unregisterPlugin = this.registerPlugin(productId);
    }
}






class $962f6652830a539e$export$da23bd36e2d631b extends (0, $ce60cbd40062948b$export$71324a662782c710) {
    isValidDuplicateStartRequest(messageId) {
        const currentMessage = (0, $63a45429e45394fc$export$236158f15971c92e).getInstance().getCurrentMessage();
        return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < 100);
    }
    async startMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $701dcb43bda5dd6a$export$21e6cc849c1dc1ab)(this.state.productId, messageId);
        const actionSubject = (0, $6580532afc76cccf$export$865c0eaaa43d90f8).START;
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::startMessageWithPlugin`
        });
        /**
		 * The Choreographer sets a 5m TTL for any message that opens, before forcefully closing it.
		 * EP also allows a messageId to re-request its start if it hasn't yet been dismissed (this is a
		 * feature of HISI. For this reason, we can mimic that functionality here (otherwise, Choreographer
		 * will block the subsequest start request attempt altogether), by checking the Choreographer's
		 * currentMessage against our productId/messageId combo here. If this *is* the currentMessage being
		 * displayed, it means it hasn't been dismissed, and we let the request dispatch for EP to make the call.
		 */ const isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
        if (isValidDuplicateStartRequest) {
            const logger = new (0, $8368be1d2c44bc45$export$efa9a398d6368992)(actionSubject, messageId, (0, $aWbP0$_)({}, this.state.metaMetricsData, additionalData), this.analyticsClient);
            const didStart = Boolean(await callback());
            if (didStart) {
                logger.started();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        plugin: this.constructor.name,
                        disposition: (0, $6580532afc76cccf$export$f6a9504bc1305cf0).STARTED,
                        timestamp: performance.now()
                    }
                });
            }
            return didStart;
        }
        // Do a just-in-time message start subscription with our callback to stargate
        this.onStart(messageId, callback);
        /**
		 * Dispatch the request to start the message, and return the response, which will
		 * either be 'started' if successful, and anything else if unsuccessful. Convert
		 * that value with a boolean check, because the consumer only cares about true/false.
		 */ const result = await this.startMessage(messageId, additionalData);
        return result === (0, $6580532afc76cccf$export$f6a9504bc1305cf0).STARTED;
    }
    async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $701dcb43bda5dd6a$export$21e6cc849c1dc1ab)(this.state.productId, messageId);
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::stopMessageWithPlugin`
        });
        // Do a just-in-time message stop subscription with our callback to stargate
        this.onStop(messageId, callback);
        /**
		 * Dispatch the request to stop the message, and return the response, which will
		 * either be 'stopped' if successful, and anything else if unsuccessful. Convert
		 * that value with a boolean check, because the consumer only cares about true/false.
		 */ const result = await this.stopMessage(messageId, additionalData);
        return result === (0, $6580532afc76cccf$export$f6a9504bc1305cf0).STOPPED;
    }
    constructor(env, metaMetricsData = {}){
        super((0, $6580532afc76cccf$export$7fb117db98868be6).ENGAGEKIT, env, metaMetricsData);
    }
}


class $1cb81ff49482deac$export$44bee9c9373d59fb extends (0, $ce60cbd40062948b$export$71324a662782c710) {
    constructor(product, env, metaMetricsData = {}){
        super(product, env, metaMetricsData);
    }
}














const $f941ac9362dec4ae$export$51d40de083bcc6e7 = (Component)=>{
    function WrapperComponent(_param) {
        var { shouldBeChoreographed: shouldBeChoreographed, withChoreographedRender: withChoreographedRender } = _param, props = (0, $aWbP0$_2)(_param, [
            "shouldBeChoreographed",
            "withChoreographedRender"
        ]);
        if (shouldBeChoreographed(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType } = props, rest = (0, $aWbP0$_2)(props, [
                "messageType"
            ]);
            const ChoreographedComponent = (0, $aWbP0$useMemo)(()=>withChoreographedRender(Component), [
                Component,
                withChoreographedRender
            ]);
            return /*#__PURE__*/ (0, $aWbP0$jsx)(ChoreographedComponent, (0, $aWbP0$_)({}, rest));
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition } = props, rest = (0, $aWbP0$_2)(props, [
            "messageType",
            "messageId",
            "onMessageDisposition"
        ]);
        return /*#__PURE__*/ (0, $aWbP0$jsx)(Component, (0, $aWbP0$_)({}, rest));
    }
    var _Component_displayName;
    WrapperComponent.displayName = `ChoreographerWrapped${((_Component_displayName = Component.displayName) !== null && _Component_displayName !== void 0 ? _Component_displayName : Component.name) || "Component"}`;
    return WrapperComponent;
};
const $f941ac9362dec4ae$export$7c574bc7a8b74124 = (Component, toggleableProp)=>{
    function WrapperComponent(_param) {
        var { shouldBeChoreographed: shouldBeChoreographed, withChoreographedToggle: withChoreographedToggle } = _param, props = (0, $aWbP0$_2)(_param, [
            "shouldBeChoreographed",
            "withChoreographedToggle"
        ]);
        if (shouldBeChoreographed(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType } = props, rest = (0, $aWbP0$_2)(props, [
                "messageType"
            ]);
            const ChoreographedComponent = (0, $aWbP0$useMemo)(()=>withChoreographedToggle(Component, toggleableProp), [
                Component,
                withChoreographedToggle,
                toggleableProp
            ]);
            return /*#__PURE__*/ (0, $aWbP0$jsx)(ChoreographedComponent, (0, $aWbP0$_)({}, rest));
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition } = props, rest = (0, $aWbP0$_2)(props, [
            "messageType",
            "messageId",
            "onMessageDisposition"
        ]);
        return /*#__PURE__*/ (0, $aWbP0$jsx)(Component, (0, $aWbP0$_)({}, rest));
    }
    var _Component_displayName;
    WrapperComponent.displayName = `ChoreographerWrapped${((_Component_displayName = Component.displayName) !== null && _Component_displayName !== void 0 ? _Component_displayName : Component.name) || "Component"}`;
    return WrapperComponent;
};


const $1cb9b8abfffa3462$export$9879a8e0db317538 = (0, $f941ac9362dec4ae$export$51d40de083bcc6e7)((0, $aWbP0$AutoDismissFlag));



const $1f2f8ee5deb7030d$export$3b4e64e77073e307 = (0, $f941ac9362dec4ae$export$51d40de083bcc6e7)((0, $aWbP0$atlaskitbanner));



const $c348d0c547d404e0$export$48ea269755562084 = (0, $f941ac9362dec4ae$export$51d40de083bcc6e7)((0, $aWbP0$atlaskitflag));



const $721d89c1e907b637$export$2b77a92f1a5ad772 = (0, $f941ac9362dec4ae$export$51d40de083bcc6e7)((0, $aWbP0$atlaskitmodaldialog));



const $48af8b4dffe59aca$export$badac9ada3a0bdf9 = (0, $f941ac9362dec4ae$export$51d40de083bcc6e7)((0, $aWbP0$Popper));



const $ae7cd0bbec30f51d$export$1033c28b5e1c2deb = (0, $f941ac9362dec4ae$export$51d40de083bcc6e7)((0, $aWbP0$Spotlight));



const $99f95a104eed4c52$export$c7313f750e9cbc9d = (0, $f941ac9362dec4ae$export$7c574bc7a8b74124)((0, $aWbP0$atlaskitinlinedialog), "isOpen");



const $3c5c9eb2b11bb3c4$export$129a32eedafa97c5 = (0, $f941ac9362dec4ae$export$7c574bc7a8b74124)((0, $aWbP0$Popup), "isOpen");


function $e3097f61aaec5ad9$export$55d2aeb17c4cfbe(productId, env, metaMetricsData = {}, choreographerOptions = {
    enableChoreographer: true
}) {
    // Instantiate our plugin instance, passing the productId through for segmenting any messageId's from any other plugins
    const plugin = new (0, $1cb81ff49482deac$export$44bee9c9373d59fb)(productId, env, metaMetricsData);
    /**
	 * React hook that provides startMessage and stopMessage functions that call through the plugin API with the provided messageId, for easy assignment to React event handlers.
	 *
	 * @param messageId The messageId to be provided to the choreographer API whenever the startMessage and stopMessage callbacks are invoked.
	 * @param startCallback A callback to be used to set local state that determines whether a message should be shown, e.g. a callback to a useState setter, or that dispatches to a reducer function.
	 * @param stopCallback A callback to be used to set local state that determines whether a message should be hidden, e.g. a callback to a useState setter, or that dispatches to a reducer function.
	 * @returns An object with startMessage and stopMessage callbacks, which contain references to the messageId to be passed to the choreographer API, so that the consumer no longer needs to specify that at call time.
	 */ const useChoreographer = (messageId, { [(0, $6580532afc76cccf$export$d33b097e0a285bc2).START]: startCallback, [(0, $6580532afc76cccf$export$d33b097e0a285bc2).STOP]: stopCallback } = {})=>{
        const isMessageStarted = (0, $aWbP0$useRef)(false);
        const startRef = (0, $aWbP0$useRef)(startCallback);
        const stopRef = (0, $aWbP0$useRef)(stopCallback);
        // Stable function reference that invokes the plugin's startMessage function, for use in components.
        const startMessage = (0, $aWbP0$useCallback)((...args)=>{
            plugin.onStart(messageId, ()=>startMessageCallback(...args));
            return plugin.startMessage(messageId);
        }, [
            messageId
        ]);
        // Callback that uses a ref to track any changes in the received startCallback parameter, so the caller doesn't have to worry about memoization
        const startMessageCallback = (0, $aWbP0$useCallback)(async (...args)=>{
            var _startRef_current;
            var _ref;
            const didMessageStart = (_ref = await ((_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.call(startRef, ...args))) !== null && _ref !== void 0 ? _ref : true;
            isMessageStarted.current = didMessageStart;
            return didMessageStart;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's stopMessage function, for use in components.
        const stopMessage = (0, $aWbP0$useCallback)((...args)=>{
            plugin.onStop(messageId, ()=>stopMessageCallback(...args));
            return plugin.stopMessage(messageId);
        }, [
            messageId
        ]);
        // Callback that uses a ref to track any changes in the received stopCallback parameter, so the caller doesn't have to worry about memoization
        const stopMessageCallback = (0, $aWbP0$useCallback)(async (...args)=>{
            var _stopRef_current;
            var _ref;
            const didMessageStop = (_ref = await ((_stopRef_current = stopRef.current) === null || _stopRef_current === void 0 ? void 0 : _stopRef_current.call(stopRef, ...args))) !== null && _ref !== void 0 ? _ref : true;
            isMessageStarted.current = !didMessageStop;
            return didMessageStop;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes whichever start or stop handler is appropriate for the message's current display state.
        // Tracking this state with a ref allows us to know the current display state in real-time, so that potentially subsequent calls
        // can be made to toggle its state, without requiring tracking a useState value and requiring rerenders to update the callback
        // with the latest display state, and without generating false blocked messages from cached/outdated toggleMessage references.
        const toggleMessage = (0, $aWbP0$useCallback)(()=>{
            return isMessageStarted.current ? stopMessage() : startMessage();
        }, [
            isMessageStarted,
            startMessage,
            stopMessage
        ]);
        // Syncs any incoming startCallback and stopCallback functions as the latest version to be invoked when a startMessage or stopMessage call is issued through the choreographer API
        (0, $aWbP0$useEffect)(()=>{
            startRef.current = startCallback;
            stopRef.current = stopCallback;
        }, [
            startCallback,
            stopCallback
        ]);
        /**
		 * At component mount, we want to default a start and stop function, which invokes these functions with no additional parameters,
		 * just to supply some sane defaults. If startMessage or stopMessage are called explicitly, they can optionally supply some extra
		 * parameters, at which point, a just-in-time registration of a new callback version will be supplied to the choreographer, which
		 * will proxy those parameter through to the target state-setter functions. But if they are not called explicitly, such as in the
		 * case where a message is started and never stopped, and is timed out from the Choreographer, we want to have a default version
		 * available to execute against.
		 *
		 * At component unmount, stop the current message, if it's displayed, and unsubscribe the stop callback for this messageId within
		 * the plugin.
		 */ (0, $aWbP0$useEffect)(()=>{
            plugin.on(messageId, {
                start: async ()=>{
                    return await startMessage() === (0, $6580532afc76cccf$export$f6a9504bc1305cf0).STARTED;
                },
                stop: async ()=>{
                    return await stopMessage() === (0, $6580532afc76cccf$export$f6a9504bc1305cf0).STOPPED;
                }
            });
            return ()=>{
                // If unsubscribing, fire the stopMessageCallback one last time to ensure the component can clear the local state responsible for displaying its message
                plugin.stopMessage(messageId);
                plugin.off(messageId);
            };
        }, [
            messageId
        ]);
        // Return the wrapped startMessage and stopMessage functions to the consumer, which will route their requests through the choreographer API with the messageId proxied straight through on behalf of the caller
        return (0, $aWbP0$useMemo)(()=>({
                startMessage: startMessage,
                stopMessage: stopMessage,
                toggleMessage: toggleMessage
            }), [
            startMessage,
            stopMessage,
            toggleMessage
        ]);
    };
    const shouldBeChoreographed = (props)=>{
        return choreographerOptions.enableChoreographer && (props === null || props === void 0 ? void 0 : props.messageType) !== undefined && (0, $6580532afc76cccf$export$dbe9e38c9d6f26d0).includes(props.messageType);
    };
    const useChoreographedRender = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
        const [shouldRender, setShouldRender] = (0, $aWbP0$useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
            start: ()=>setShouldRender(true)
        });
        (0, $aWbP0$useEffect)(()=>{
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition === null || onMessageDisposition === void 0 ? void 0 : onMessageDisposition(disposition);
            };
            startMessageAsync();
            return ()=>void stopMessage();
        }, [
            messageId,
            onMessageDisposition,
            startMessage,
            stopMessage
        ]);
        return shouldRender;
    };
    const withChoreographedRender = (Component)=>{
        function ChoreographedComponent(_param) {
            var { messageId: messageId, onMessageDisposition: onMessageDisposition } = _param, props = (0, $aWbP0$_2)(_param, [
                "messageId",
                "onMessageDisposition"
            ]);
            const shouldRender = useChoreographedRender({
                messageId: messageId,
                onMessageDisposition: onMessageDisposition
            });
            if (shouldRender) // Need to cast "props" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition"> is the same as T
            return /*#__PURE__*/ (0, $aWbP0$jsx)(Component, (0, $aWbP0$_)({}, props));
            return null;
        }
        var _Component_displayName;
        ChoreographedComponent.displayName = `Choreographed${(_Component_displayName = Component.displayName) !== null && _Component_displayName !== void 0 ? _Component_displayName : "Component"}`;
        return ChoreographedComponent;
    };
    const withChoreographedToggle = (Component, toggleableProp)=>{
        function ChoreographedComponent(_param) {
            var { messageId: messageId, onMessageDisposition: onMessageDisposition } = _param, rest = (0, $aWbP0$_2)(_param, [
                "messageId",
                "onMessageDisposition"
            ]);
            // Need to cast "rest" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition"> is the same as T
            const props = rest;
            const [shouldRender, setShouldRender] = (0, $aWbP0$useState)(false);
            const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
                start: ()=>setShouldRender(true),
                stop: ()=>setShouldRender(false)
            });
            (0, $aWbP0$useEffect)(()=>{
                if (props[toggleableProp]) {
                    const startMessageAsync = async ()=>{
                        const disposition = await startMessage();
                        onMessageDisposition === null || onMessageDisposition === void 0 ? void 0 : onMessageDisposition(disposition);
                    };
                    startMessageAsync();
                } else stopMessage();
                return ()=>{
                    stopMessage();
                };
            }, [
                props[toggleableProp],
                messageId,
                onMessageDisposition,
                startMessage,
                stopMessage
            ]);
            return /*#__PURE__*/ (0, $aWbP0$jsx)(Component, (0, $aWbP0$_1)((0, $aWbP0$_)({}, props), {
                [toggleableProp]: shouldRender
            }));
        }
        return ChoreographedComponent;
    };
    function wrapWithFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $aWbP0$jsx)(MaybeChoreographedComponent, (0, $aWbP0$_1)((0, $aWbP0$_)({}, props), {
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedRender: withChoreographedRender
            }));
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    function wrapWithToggleFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $aWbP0$jsx)(MaybeChoreographedComponent, (0, $aWbP0$_1)((0, $aWbP0$_)({}, props), {
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            }));
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    const AutoDismissFlag = wrapWithFactoryFunctions((0, $1cb9b8abfffa3462$export$9879a8e0db317538));
    const Banner = wrapWithFactoryFunctions((0, $1f2f8ee5deb7030d$export$3b4e64e77073e307));
    const Flag = wrapWithFactoryFunctions((0, $c348d0c547d404e0$export$48ea269755562084));
    const Modal = wrapWithFactoryFunctions((0, $721d89c1e907b637$export$2b77a92f1a5ad772));
    const Popper = wrapWithFactoryFunctions((0, $48af8b4dffe59aca$export$badac9ada3a0bdf9));
    const Spotlight = wrapWithFactoryFunctions((0, $ae7cd0bbec30f51d$export$1033c28b5e1c2deb));
    const InlineDialog = wrapWithToggleFactoryFunctions((0, $99f95a104eed4c52$export$c7313f750e9cbc9d));
    // Would ideally like to use wrapWithToggleFactoryFunctions here, but the Popup component's props is a union
    // type, and that for some reason causes ToggleableChoreographerUtilities to be passed through to the
    // consumer-exposed Popup component's prop type, which is not what we want, so we'll just wrap it manually here
    const Popup = function() {
        function WrappedPopup(props) {
            return /*#__PURE__*/ (0, $aWbP0$jsx)((0, $3c5c9eb2b11bb3c4$export$129a32eedafa97c5), (0, $aWbP0$_1)((0, $aWbP0$_)({}, props), {
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            }));
        }
        WrappedPopup.displayName = `ChoreographerFactory(${(0, $3c5c9eb2b11bb3c4$export$129a32eedafa97c5).displayName})`;
        return WrappedPopup;
    }();
    // Return these items from the factory function for use within React products
    return {
        plugin: plugin,
        useChoreographer: useChoreographer,
        shouldBeChoreographed: shouldBeChoreographed,
        useChoreographedRender: useChoreographedRender,
        withChoreographedRender: withChoreographedRender,
        withChoreographedToggle: withChoreographedToggle,
        AutoDismissFlag: AutoDismissFlag,
        Banner: Banner,
        Flag: Flag,
        InlineDialog: InlineDialog,
        Modal: Modal,
        Popper: Popper,
        Popup: Popup,
        Spotlight: Spotlight
    };
}





export {$63a45429e45394fc$export$236158f15971c92e as Choreographer, $bfa09a771ddec9c1$export$56ac8ebc9870b1b9 as envType, $962f6652830a539e$export$da23bd36e2d631b as EngagekitChoreographerPlugin, $1cb81ff49482deac$export$44bee9c9373d59fb as ProductChoreographerPlugin, $ce60cbd40062948b$export$71324a662782c710 as ChoreographerPlugin, $e3097f61aaec5ad9$export$55d2aeb17c4cfbe as choreographerFactory, $6580532afc76cccf$export$865c0eaaa43d90f8 as MessageAction, $6580532afc76cccf$export$f6a9504bc1305cf0 as MessageDeliveryStatus, $6580532afc76cccf$export$d33b097e0a285bc2 as MessageEventType, $6580532afc76cccf$export$7fb117db98868be6 as ProductIds};
//# sourceMappingURL=index.js.map
